import {observable} from 'mobx';
import {Copmany, Interface} from '../types/edi';

export const EdiStore = observable.object({
    interfaces: [],
    common: false,
    companies: [],
    searchValue: '',
    sendAll: false,
    setInterfaces(interfaces: Array<Interface>) {
        this.interfaces = interfaces;

        const comps = [];
        this.interfaces.forEach(({companies}) => {
            companies.forEach((company: Copmany) => {
                const duplicate = comps.some((comp: Copmany) => {
                    return comp.label === company.label;
                });
                if (!duplicate) {
                    comps.push(company);
                }
            });
        });

        const common = comps.find((comp: Copmany) => {
            return comp.label === 'EI_EMAIL';
        });

        if (common) {
            this.setCompanies([common]);
            this.common = true;
        } else {
            this.setCompanies(comps);
        }
    },
    setCompanies(companies: Array<Copmany>) {
        this.companies = companies;
    },
    setSearchValue(value: string) {
        this.searchValue = value;
    },
    setIsAllSelected(selected: boolean) {
        this.list.forEach((company: Copmany) => (company.isSelected = selected));
    },
    initStore() {
        this.interfaces = [];
        this.companies = [];

        this.searchValue = '';
        this.sendAll = false;
        this.common = false;
    },
    get selected() {
        return this.list.filter((company: Copmany) => company.isSelected);
    },
    get list() {
        return this.companies.filter((company: Copmany) =>
            company.label.toLowerCase().includes(this.searchValue.toLowerCase())
        );
    },
    get hasSelected(): boolean {
        return this.selected.length > 0;
    },
    get hasList(): boolean {
        return this.list.length > 0;
    },
    get isAllSelected(): boolean {
        return this.hasList && this.list.length === this.selected.length;
    }
});
